import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {TokenParam} from "../../types/types";
import {VerifyTokenViewModel} from "../../viewmodel/token/VerifyTokenViewModel";

export const VerifyToken: React.FC = () => {

    const { token } = useParams<TokenParam>();

    const { verifyToken } = VerifyTokenViewModel()

    useEffect(() => {
        if (token) {
            verifyToken(token).then(response =>
                window.location.href =
                    `${window.location.protocol}//${window.location.host}/${response}`
            )
        }
    }, [verifyToken, token])

    return <></>

}